/*
# Copyright (c) 2023-2025 Kreasoft / Vincent Latourelle
# 
# Auteur : Vincent Latourelle
# Développé pour le compte de : Cavale Performance
# 
# Propriété intellectuelle : Kreasoft
# Licence : Usage interne uniquement / Non transférable sans entente écrite
#
# Toute reproduction, modification ou redistribution du code est interdite
# sans autorisation explicite de Kreasoft.
*/
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./i18n";
import { Provider } from 'react-redux';
import store from './rtk/store';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
